import {
  put, takeLatest, all, select,
} from 'redux-saga/effects';
import { notification } from 'antd';
import dayjs from 'dayjs';
import TrackerActions from '@Actions/trackerActions';
import InvoiceActions, { invoiceActionTypes } from '../actions/invoiceActions';
import InvoiceServices from '../services/invoiceServices';

/**
 * @param action
 */
function* _createInvoice(action) {
  try {
    yield put(InvoiceActions.createInvoiceLoading(true));
    const invoice = yield InvoiceServices.createInvoice(action.payload);
    if (invoice.success) {
      yield put(TrackerActions.trackAction(invoiceActionTypes.CREATE_INVOICE.SUCCESS, invoice.data));
      const invoiceType = invoice?.data?.[0]?.invoice_type;
      notification.open({
        type: 'success',
        message: invoiceType === 'CONSUMPTION_ORDER'
          ? 'Consumption Order successfully created'
          : 'Invoice successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(invoice?.data?.[0]);
      yield put(InvoiceActions.createInvoiceLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: invoice.message,
        duration: 4,
        placement: 'top',
      });
      yield put(InvoiceActions.createInvoiceLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
    });
    yield put(InvoiceActions.createInvoiceLoading(false));
  }
}

/**
 *
 */
function* createInvoice() {
  yield takeLatest(invoiceActionTypes.CREATE_INVOICE.REQUEST, _createInvoice);
}

/**
 * @param action
 */
function* _updateInvoice(action) {
  try {
    yield put(InvoiceActions.updateInvoiceLoading(true));
    const invoice = yield InvoiceServices.updateInvoice(action.payload);
    if (invoice.success) {
      yield put(TrackerActions.trackAction(invoiceActionTypes.UPDATE_INVOICE.SUCCESS, invoice.data));
      notification.open({
        type: 'success',
        message: 'Invoice successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(InvoiceActions.updateInvoiceLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: 'Error in updating Invoice',
        description: invoice?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(InvoiceActions.updateInvoiceLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(InvoiceActions.updateInvoiceLoading(false));
  }
}

/**
 *
 */
function* updateInvoice() {
  yield takeLatest(invoiceActionTypes.UPDATE_INVOICE.REQUEST, _updateInvoice);
}

function* _quickUpdateInvoice(action) {
  try {
    const state = yield select();
    const { selectedInvoice } = state?.InvoiceReducers;
    let invoiceCopy = JSON.parse(JSON.stringify(selectedInvoice));
    const invoiceCopy2 = JSON.parse(JSON.stringify(selectedInvoice));
    invoiceCopy = { ...invoiceCopy, ...action.payload };
    yield put(InvoiceActions.getInvoiceByIdSuccess(invoiceCopy));
    yield put(InvoiceActions.quickUpdateInvoiceLoading(true));

    const invoice = yield InvoiceServices.quickUpdateInvoice(action.payload);
    if (invoice.success) {
      notification.open({
        type: 'success',
        message: 'Updating invoice successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: invoice?.message || 'Error! while updating invoice',
        duration: 4,
        placement: 'top',
      });
      if (action?.rollback) {
        action?.rollback();
      }
      yield put(InvoiceActions.getInvoiceByIdSuccess(invoiceCopy2));
    }
    yield put(InvoiceActions.quickUpdateInvoiceLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(InvoiceActions.quickUpdateInvoiceLoading(false));
  }
}

/**
   *
   */
function* quickUpdateInvoice() {
  yield takeLatest(invoiceActionTypes.QUICK_UPDATE_INVOICE.REQUEST, _quickUpdateInvoice);
}

/**
 * @param action
 */
function* _getInvoice(action) {
  try {
    InvoiceActions.getInvoiceSuccess(null);
    yield put(InvoiceActions.getInvoiceLoading(true));
    const {
      orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, callback, isMarketplaceInvoice, accountManagerIds, source, stockStatus, excludeInvoiceIds, excludeGRNCustomerIds, invoiceType,
    } = action;
    const invoice = yield InvoiceServices.getInvoice(orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, isMarketplaceInvoice, accountManagerIds, source, stockStatus, excludeInvoiceIds, excludeGRNCustomerIds, invoiceType);
    yield put(InvoiceActions.getInvoiceSuccess(invoice));
    if (callback) callback(invoice);
    yield put(InvoiceActions.getInvoiceLoading(false));
  } catch (error) {
    yield put(InvoiceActions.getInvoiceLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getInvoice() {
  yield takeLatest(invoiceActionTypes.GET_INVOICE.REQUEST, _getInvoice);
}

/**
 * @param action
 */
function* _getInvoiceById(action) {
  try {
    yield put(InvoiceActions.getInvoiceByIdSuccess(null));
    yield put(InvoiceActions.getInvoiceByIdLoading(true));
    const {
      orgId, tenantId, invoiceId, callback,
    } = action;
    const selectedInvoice = yield InvoiceServices.getInvoice(orgId, null, invoiceId);
    yield put(InvoiceActions.getInvoiceByIdSuccess(selectedInvoice?.data?.invoices?.[0] || {}));
    if (callback) callback(selectedInvoice?.data?.invoices?.[0] || {});
    yield put(InvoiceActions.getInvoiceByIdLoading(false));
  } catch (error) {
    yield put(InvoiceActions.getInvoiceByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getInvoiceById() {
  yield takeLatest(invoiceActionTypes.GET_INVOICE_BY_ID.REQUEST, _getInvoiceById);
}

/**
 * @param action
 */
function* _updateInvoiceStatus(action) {
  try {
    yield put(InvoiceActions.updateInvoiceStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const invoiceStatus = yield InvoiceServices.updateInvoiceStatus(payload);

    if (invoiceStatus.success) {
      notification.open({
        type: 'success',
        message: `${window?.location?.pathname?.includes('invoice') ? 'Invoice' : (window?.location?.pathname?.includes('consumption') ? 'Consumption Order' : 'Document')} status successfully updated`,
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: invoiceStatus?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InvoiceActions.updateInvoiceStatusLoading(false));
  } catch (error) {
    yield put(InvoiceActions.updateInvoiceStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* updateInvoiceStatus() {
  yield takeLatest(invoiceActionTypes.UPDATE_STATUS_INVOICE.REQUEST, _updateInvoiceStatus);
}

/**
 * @param action
 */
function* _deleteInvoice(action) {
  try {
    yield put(InvoiceActions.deleteInvoiceLoading(true));
    const so = yield InvoiceServices.deleteInvoice(action.payload);
    const invoiceType = so?.data?.[0]?.invoice_type;
    if (so.success) {
      notification.open({
        type: 'success',
        message: invoiceType === 'CONSUMPTION_ORDER'
          ? 'Consumption Order successfully deleted'
          : 'Invoice successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InvoiceActions.deleteInvoiceLoading(false));
  } catch (error) {
    yield put(InvoiceActions.deleteInvoiceLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* deleteInvoice() {
  yield takeLatest(invoiceActionTypes.DELETE_INVOICE.REQUEST, _deleteInvoice);
}

/**
 * @param action
 */
function* _updateInvoiceWorkflowStep(action) {
  try {
    yield put(InvoiceActions.updateInvoiceWorkflowStepLoading(true));
    const so = yield InvoiceServices.updateInvoiceWorkflowStep(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Invoice successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InvoiceActions.updateInvoiceWorkflowStepLoading(false));
  } catch (error) {
    yield put(InvoiceActions.updateInvoiceWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* updateInvoiceWorkflowStep() {
  yield takeLatest(invoiceActionTypes.UPDATE_INVOICE_WORKFLOW_STEP.REQUEST, _updateInvoiceWorkflowStep);
}

/**
 * @param action
 */
function* _linkIncomingPayment(action) {
  try {
    yield put(InvoiceActions.linkIncomingPaymentsLoading(true));
    const payment = yield InvoiceServices.LinkInvoicePayments(action.payload);
    if (payment.success) {
      notification.open({
        type: 'success',
        message: 'Linked payment Successfully !',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InvoiceActions.linkIncomingPaymentsLoading(false));
  } catch (error) {
    yield put(InvoiceActions.linkIncomingPaymentsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* linkIncomingPayment() {
  yield takeLatest(invoiceActionTypes.INVOICE_LINK_PAYMENT.REQUEST, _linkIncomingPayment);
}

/**
 * @param action
 */
function* _unlinkIncomingPayment(action) {
  try {
    yield put(InvoiceActions.unlinkIncomingPaymentLoading(true));
    const payment = yield InvoiceServices.UnlinkInvoicePayments(action.invoicePaymentId);
    if (payment?.success) {
      notification.open({
        type: 'success',
        message: 'Unlinked payment Successfully!',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InvoiceActions.unlinkIncomingPaymentLoading(false));
  } catch (error) {
    yield put(InvoiceActions.unlinkIncomingPaymentLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* unlinkIncomingPayment() {
  yield takeLatest(invoiceActionTypes.INVOICE_UNLINK_PAYMENT.REQUEST, _unlinkIncomingPayment);
}

function* _downloadInvoice(action) {
  const { payload, callback } = action;
  try {
    yield put(InvoiceActions.downloadInvoiceLoading(true));
    const invoices = yield InvoiceServices.downloadInvoices(payload?.invoiceIds, payload?.fileType, payload?.sortBy);
    if (callback) {
      callback();
    }
    if (invoices) {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = `INVOICES_${dayjs().format('DD-MM-YYYY_hh:mm_A')}`;
      link.href = URL.createObjectURL(
        new Blob([invoices], { type: invoices.type }),
      );
      link.click();
    }
    yield put(InvoiceActions.downloadInvoiceLoading(false));
  } catch (error) {
    yield put(InvoiceActions.downloadInvoiceLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* downloadInvoice() {
  yield takeLatest(invoiceActionTypes.DOWNLOAD_INVOICE.REQUEST, _downloadInvoice);
}

function* _downloadShippingLabels(action) {
  try {
    const {
      invoiceIds, fileType, withPrice,
    } = action;
    yield put(InvoiceActions.downloadShippingLabelsLoading(true));
    const invoices = yield InvoiceServices.downloadShippingLabels(invoiceIds, fileType, withPrice);

    if (invoices) {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = `INVOICES_${dayjs().format('DD-MM-YYYY_hh:mm_A')}`;
      link.href = URL.createObjectURL(
        new Blob([invoices], { type: invoices.type }),
      );
      link.click();
      if (action?.callback) {
        action.callback();
      }
    }
    yield put(InvoiceActions.downloadShippingLabelsLoading(false));
  } catch (error) {
    yield put(InvoiceActions.downloadShippingLabelsLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* downloadShippingLabels() {
  yield takeLatest(invoiceActionTypes.DOWNLOAD_SHIPPING_LABELS.REQUEST, _downloadShippingLabels);
}

/**
 *  Download Invoice List
 */

function* _downloadInvoiceList(action) {
  try {
    yield put(InvoiceActions.downloadInvoiceListLoading(true));
    const response = yield InvoiceServices.downloadInvoiceList(action.payload);
    if (response?.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: response?.message,
        duration: 4,
        placement: 'top',
      });
    }
    action.callback();
    yield put(InvoiceActions.downloadInvoiceListLoading(false));
  } catch (error) {
    yield put(InvoiceActions.downloadInvoiceListLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* downloadInvoiceList() {
  yield takeLatest(invoiceActionTypes.DOWNLOAD_INVOICE_LIST.REQUEST, _downloadInvoiceList);
}

function* _createBulkReturns(action) {
  try {
    yield put(InvoiceActions.createBulkReturnsLoading(true));
    const response = yield InvoiceServices.createBulkReturns(action.payload);
    if (response?.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. Please check your recent bulk upload to track the status.',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: response?.message || 'Something went wrong',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InvoiceActions.createBulkReturnsLoading(false));
  } catch (error) {
    yield put(InvoiceActions.createBulkReturnsLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Something went wrong',
      duration: 4,
      placement: 'top',
    });
  }
}

function* createBulkReturns() {
  yield takeLatest(invoiceActionTypes.CREATE_BULK_RETURNS.REQUEST, _createBulkReturns);
}

// issue Stock for invoice
function* _issueStockForInvoice(action) {
  try {
    yield put(InvoiceActions.issueStockForInvoiceLoading(true));
    const response = yield InvoiceServices.issueStockForInvoice(action.payload);
    if (response?.success) {
      notification.open({
        type: 'success',
        message: 'Stock issued successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: response?.message || 'Something went wrong',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InvoiceActions.issueStockForInvoiceLoading(false));
  } catch (error) {
    yield put(InvoiceActions.issueStockForInvoiceLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Something went wrong',
      duration: 4,
      placement: 'top',
    });
  }
}

function* issueStockForInvoice() {
  yield takeLatest(invoiceActionTypes.ISSUE_STOCK_FOR_INVOICE.REQUEST, _issueStockForInvoice);
}

// revert Stock for invoice
function* _revertStockForInvoice(action) {
  try {
    yield put(InvoiceActions.revertStockForInvoiceLoading(true));
    const response = yield InvoiceServices.revertStockForInvoice(action.payload);
    if (response?.success) {
      notification.open({
        type: 'success',
        message: 'Stock reverted successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: response?.message || 'Something went wrong',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(InvoiceActions.revertStockForInvoiceLoading(false));
  } catch (error) {
    yield put(InvoiceActions.revertStockForInvoiceLoading(false));
    notification.open({
      type: 'error',
      message: error?.message || 'Something went wrong',
      duration: 4,
      placement: 'top',
    });
  }
}

function* revertStockForInvoice() {
  yield takeLatest(invoiceActionTypes.REVERT_STOCK_FOR_INVOICE.REQUEST, _revertStockForInvoice);
}

export default function* invoiceSaga() {
  yield all([
    createInvoice(),
    getInvoice(),
    updateInvoice(),
    getInvoiceById(),
    updateInvoiceStatus(),
    updateInvoiceWorkflowStep(),
    deleteInvoice(),
    linkIncomingPayment(),
    unlinkIncomingPayment(),
    downloadInvoice(),
    downloadShippingLabels(),
    downloadInvoiceList(),
    createBulkReturns(),
    quickUpdateInvoice(),
    issueStockForInvoice(),
    revertStockForInvoice(),
  ]);
}
